import { useEffect, useState } from 'react'
import api from '../../lib/api/api'

export type TtsMode = 'server' | 'browser'

export interface Capabilities {
  /** null until the platform answered (or when it could not be asked) */
  tts: TtsMode | null
}

// one request per page load: the platform does not change while the app runs
let pending: Promise<Capabilities> | null = null

function fetchCapabilities(): Promise<Capabilities> {
  if (!pending) {
    pending = api
      .get('/api/v1/system/capabilities')
      .then(resp => ({ tts: resp.data?.tts === 'browser' ? 'browser' : 'server' } as Capabilities))
      .catch(() => {
        pending = null
        return { tts: null }
      })
  }
  return pending
}

/** What this platform offers the client (GET /api/v1/system/capabilities). */
export function useCapabilities(): Capabilities {
  const [capabilities, setCapabilities] = useState<Capabilities>({ tts: null })
  useEffect(() => {
    let alive = true
    fetchCapabilities().then(c => {
      if (alive) setCapabilities(c)
    })
    return () => {
      alive = false
    }
  }, [])
  return capabilities
}
